import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem 0 0.4rem 0;
  max-width: 100%;
`
